import { gql } from '@apollo/client'

export const GET_SAVED_PAYMENT_INFO_QUERY = gql`
  query getSavedPaymentInfo {
    paymentInfo {
      last4
      brand
      expireDate
      expired
    }
  }
`

export const STRIPE_ONE_TIME_PURCHASE_MUTATION = gql`
  mutation doStripeOneTimePurchase($input: StripePaymentInput!) {
    stripePurchase(input: $input) {
      order {
        id
        user {
          email
          id
        }
      }
      queued
    }
  }
`

export const GUEST_STRIPE_PURCHASE_MUTATION = gql`
  mutation doStripeOneTimeGuestCheckout($input: GuestStripePaymentInput!) {
    guestStripePurchase(input: $input) {
      order {
        id
        user {
          email
          id
        }
      }
      userCreatedWithOrder
      userToken
    }
  }
`

export const STRIPE_MONTHLY_SUBSCRIPTION_MUTATION = gql`
  mutation doStripeMonthlySubscription($input: StripePaymentInput!) {
    stripeSubscription(input: $input) {
      subscription {
        id
      }
      queued
    }
  }
`

export interface PurchaseRequest {
  offerSlug: string
  stripeToken?: string
}

export interface GuestPurchaseRequest extends PurchaseRequest {
  guestCheckout: boolean
  email: string
}

export interface PaymentInfo {
  last4: string
  brand: string
  expireDate: string
  expired: boolean
}
